import React, { useState } from 'react';
import { Box, Popover, Tooltip } from '@mui/material';
import { PRES } from '../chrome';
import { focusVisibleSx } from '../ui/focus';
import ColorField from './ColorField';

interface ColorPopoverButtonProps {
  color: string;
  label: string;
  disabled?: boolean;
  allowNone?: boolean;
  size?: number;
  onChange: (color: string) => void;
}

const ColorPopoverButton: React.FC<ColorPopoverButtonProps> = ({
  color,
  label,
  disabled,
  allowNone,
  size = 18,
  onChange,
}) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const transparent = !color || color === 'transparent';

  return (
    <>
      <Tooltip title={label} arrow>
        <Box component="span" sx={{ display: 'inline-flex', flexShrink: 0 }}>
          <Box
            component="button"
            type="button"
            aria-label={label}
            disabled={disabled}
            onClick={(event) => setAnchor(event.currentTarget)}
            sx={{
              width: size,
              height: size,
              borderRadius: '50%',
              bgcolor: transparent ? PRES.white : color,
              backgroundImage: transparent
                ? 'linear-gradient(135deg, transparent 43%, #c0392b 46%, #c0392b 54%, transparent 57%)'
                : undefined,
              border: `1px solid ${PRES.borderStrong}`,
              boxShadow: `0 0 0 1px ${PRES.white}`,
              p: 0,
              cursor: disabled ? 'default' : 'pointer',
              opacity: disabled ? 0.45 : 1,
              ...focusVisibleSx,
            }}
          />
        </Box>
      </Tooltip>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { sx: { p: 1.5, width: 260 } } }}
      >
        <ColorField
          flush
          label={label}
          value={color}
          allowNone={allowNone}
          disabled={disabled}
          onChange={onChange}
        />
      </Popover>
    </>
  );
};

export default ColorPopoverButton;
